import React from "react";
import { Routes, Route } from "react-router-dom";

import ThemeProvider from './context/ThemeProvider'
import Landing from "./pages/Landing";

function App() {
  return (
    <ThemeProvider>
      <Routes>
        <Route path="/" element={<Landing />} />
      </Routes>
    </ThemeProvider>
  );
}

export default App;
